import { usePortfolioTheme } from "../../contexts/PortfolioTheme";

const ThemeToggle = () => {
  const { dark, toggle } = usePortfolioTheme();

  return (
    <button className={`theme-toggle${dark ? " theme-toggle--dark" : ""}`} type="button" onClick={toggle} aria-label={dark ? "Switch to light mode" : "Switch to dark mode"} aria-pressed={dark}>
      <span className="theme-toggle-thumb" aria-hidden="true" />
      <span className="theme-toggle-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42m0-14.14-1.42 1.42M6.35 17.65l-1.42 1.42" /></svg>
      </span>
      <span className="theme-toggle-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false"><path d="M20.2 15.6A8.5 8.5 0 0 1 8.4 3.8 8.5 8.5 0 1 0 20.2 15.6Z" /></svg>
      </span>
    </button>
  );
};

export default ThemeToggle;
